import { useCallback, useRef } from "react";
import { Navigation } from "swiper";
import { Skeleton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getPrincipalPbf } from "../../../../services/purchaseApi";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const PrincipalSwiper = () => {
  const sliderRef = useRef(null);
  const navigationNextRef = useRef(null);
  const navigationPrevRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const { data: dataPrincipal, isFetching: isFetchingPrincipal } = useQuery({
    queryKey: ["rank-principle"],
    queryFn: () => getPrincipalPbf(),
    refetchOnWindowFocus: false,
  });

  return (
    <div className="w-full overflow-hidden relative px-12 ">
      <div
        className="z-5 bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute left-0 top-0 bottom-0 my-auto"
        id="slideLeft"
        onClick={() =>
          (document.getElementById("containerScrollSearch").scrollLeft -= 80)
        }
      >
        <FaChevronLeft />
      </div>
      <div
        className="scroll-smooth z-5 bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute right-0 top-0 bottom-0 my-auto"
        id="slideRight"
        onClick={() =>
          (document.getElementById("containerScrollSearch").scrollLeft += 80)
        }
      >
        <FaChevronRight />
      </div>

      <div
        className="w-full flex gap-[24px] px-8 overflow-x-auto hide-scroll scroll-smooth"
        id="containerScrollSearch"
      >
        {dataPrincipal && !isFetchingPrincipal ? (
          dataPrincipal.slice(0, 10).map((item, i) => (
            <div className="w-fit">
              <a
                href={`/purchase-pbf/product-list/principal/${item.principal_id}`}
              >
                <div className="text-center flex flex-col justify-between items-center h-full">
                  <div className="bg-white rounded-full w-[80px] h-[80px] flex items-center justify-center p-2 mb-2 cursor-pointer hover:shadow-lg">
                    <img
                      src={item.logo}
                      className="w-full h-full object-contain rounded-full"
                    />
                  </div>
                  <p className="text-center">{item.principal_name_alias}</p>
                </div>
              </a>
            </div>
          ))
        ) : isFetchingPrincipal ? (
          [...Array(8).keys()].map((item) => {
            return (
              <div className="w-fit">
                <Skeleton variant="circular" width={80} height={80} />
              </div>
            );
          })
        ) : (
          <p>Tidak ada data</p>
        )}
      </div>
    </div>

    // <div className="w-full h-[100px]">
    //   {isFetchingPrincipal ? null : (
    //     // <div
    //     //   className={`w-full flex justify-between items-center bg-red-100 z-10 ${
    //     //     dataPrincipal &&
    //     //     !isFetchingPrincipal &&
    //     //     dataPrincipal.length <= 8
    //     //       ? "lg:hidden"
    //     //       : ""
    //     //   }`}
    //     // >
    //     //   <button ref={navigationPrevRef} onClick={handlePrev}>
    //     //     <div className="w-[32px] h-[32px] p-2 bg-white rounded-full text-blue-500 flex items-center justify-center hover:bg-gray-100 shadow-md">
    //     //       <FaChevronLeft className="w-full h-full" />
    //     //     </div>
    //     //   </button>
    //     //   <button ref={navigationNextRef} onClick={handleNext}>
    //     //     <div className="w-[32px] h-[32px] p-2 bg-white rounded-full text-blue-500 flex items-center justify-center hover:bg-gray-100 shadow-md">
    //     //       <FaChevronRight className="w-full h-full" />
    //     //     </div>
    //     //   </button>
    //     // </div>

    //     // <div className="w-full bg-red-100 h-full">bsdf</div>

    //     <div className="z-10 h-full">
    //       <div
    //         className="z-5 bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute left-0 top-0 bottom-0 my-auto"
    //         id="slideLeft"
    //         onClick={handlePrev}
    //       >
    //         <FaChevronLeft />
    //       </div>
    //       <div
    //         className="scroll-smooth z-5 bg-white rounded-full flex items-center justify-center p-1 border cursor-pointer hover:bg-gray-100 w-[28px] h-[28px] absolute right-0 top-0 bottom-0 my-auto"
    //         id="slideRight"
    //         onClick={handleNext}
    //       >
    //         <FaChevronRight />
    //       </div>
    //     </div>
    //   )}

    //   <Swiper
    //     ref={sliderRef}
    //     slidesPerView={2}
    //     spaceBetween={8}
    //     navigation={{
    //       prevEl: navigationPrevRef.current,
    //       nextEl: navigationNextRef.current,
    //     }}
    //     onBeforeInit={(swiper) => {
    //       swiper.navigation.nextEl = navigationNextRef.current;
    //       swiper.navigation.prevEl = navigationPrevRef.current;
    //     }}
    //     modules={[Navigation]}
    //     breakpoints={{
    //       640: {
    //         slidesPerView: 2,
    //         spaceBetween: 8,
    //       },
    //       768: {
    //         slidesPerView: 4,
    //         spaceBetween: 8,
    //       },
    //       1024: {
    //         slidesPerView: 5,
    //         spaceBetween: 8,
    //       },
    //       1440: {
    //         slidesPerView: 8,
    //         spaceBetween: 8,
    //       },
    //     }}
    //     className="flex justify-center w-full grid grid-cols-1 text-[#2C3E5D]"
    //   >
    //     <div className="relative" id="containerScrollRecent">
    //       {dataPrincipal && !isFetchingPrincipal ? (
    //         dataPrincipal.map((item, i) => (
    //           <SwiperSlide
    //             virtualIndex={i}
    //             className="w-fit flex items-start justify-center"
    //             style={{ width: "fit-content" }}
    //           >
    //             <a
    //               href={`/purchase-pbf/product-list/principal/${item.principal_id}`}
    //             >
    //               <div className="text-center flex flex-col justify-between items-center h-full">
    //                 <div className="bg-white rounded-full w-[80px] h-[80px] flex items-center justify-center p-2 mb-2 cursor-pointer hover:shadow-lg">
    //                   <img
    //                     src={item.logo}
    //                     className="w-full h-full object-contain rounded-full"
    //                   />
    //                 </div>
    //                 <p className="text-center">{item.principal_name_alias}</p>
    //               </div>
    //             </a>
    //           </SwiperSlide>
    //         ))
    //       ) : isFetchingPrincipal ? (
    //         [...Array(8).keys()].map(() => {
    //           return (
    //             <SwiperSlide>
    //               <Skeleton variant="circular" width={80} height={80} />
    //             </SwiperSlide>
    //           );
    //         })
    //       ) : (
    //         <p>Tidak ada data principal</p>
    //       )}
    //     </div>
    //   </Swiper>
    // </div>
  );
};

export default PrincipalSwiper;
